export default "__VITE_ASSET__BbRRglWk__"